export async function checkNetwork () {
  try {
    const res = await fetch('https://s3-fra01-eu.mykeeta.net/sailorfempcpublic/network_test.png', {
      cache: 'no-store',
    })
    return res.ok
  } catch (error) {
    return false
  }
}

export default async function refreshPage ({ needDelay, onFailed }: { needDelay: boolean; onFailed?: () => void }) {
  const isOnline = navigator.onLine
  if (isOnline) {
    const isNetworkOk = await checkNetwork()
    if (isNetworkOk) {
      window.location.reload()
    } else {
      // 延迟1s为了给用户“刷新”的感觉，不至于看不到onFailed效果
      if (needDelay) {
        setTimeout(() => {
          onFailed?.()
        }, 1000)
      } else {
        onFailed?.()
      }
    }
  } else {
    if (needDelay) {
      setTimeout(() => {
        onFailed?.()
      }, 1000)
    } else {
      onFailed?.()
    }
  }
}
